import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommentsComponent } from '@shared/components/comments/comments.component';
import { DesignNotesProvider } from '../../../services/design-notes-provider.service';

export interface CommentsDialogData {
  designId: number;
  designName: string | null;
}

@Component({
  selector: 'app-comments-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, CommentsComponent],
  templateUrl: './comments-dialog.component.html',
  styleUrl: './comments-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentsDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<CommentsDialogComponent>);
  protected readonly data = inject<CommentsDialogData>(MAT_DIALOG_DATA);
  protected readonly designNotesProvider = inject(DesignNotesProvider);

  protected onClose(): void {
    this.dialogRef.close();
  }
}